function updateCartGift() {
  const elemFreeGift = document.querySelector("#freegift");
  if (elemFreeGift && window.Shopify.country == 'US') {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const productIdToAdd = elemFreeGift.value;
        const quantityToAdd = 1;
        // const minPrice = 1;
        // const subtotal = cart.total_price / 100;

        const productInCart = cart.items.find(
          (item) => item.id == productIdToAdd
        );
        const isMobile = isMobileDevice();

        let cartElement = isMobile
          ? document.querySelector("cart-drawer")
          : document.querySelector("cart-notification");
        if (isMobile) {
          cartElement.classList.remove("is-empty");
        }
        let productGift = cart.items.find((item) => item.id == productIdToAdd);
        if (productGift && cart.items.length <= 1) {
          fetch(`/cart/change.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: productGift.key,
              quantity: 0,
              sections: cartElement
                .getSectionsToRender()
                .map((section) => section.id),
            }),
          })
            .then((response) => response.json())
            .then((data) => handleAddToCartResponseGift(data, cartElement, 0))
            .catch((error) => {
              console.error("Error al remover el producto:", error);
            });
          return true;
        }
        if (!productInCart) {
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: productIdToAdd,
              quantity: quantityToAdd,
              sections: cartElement
                .getSectionsToRender()
                .map((section) => section.id),
            }),
          })
            .then((response) => response.json())
            .then((data) => handleAddToCartResponseGift(data, cartElement, 1))
            .catch((error) => {
              console.error("Error al agregar el producto:", error);
            });
        }

        // let productGift = cart.items.find(item => item.id == productIdToAdd && item.final_price == 0)
      })
      .catch((error) => {
        console.error("Error al obtener el carrito:", error);
      });
  }
}

function isMobileDevice() {
  return window.innerWidth <= 768 || /Mobi|Android/i.test(navigator.userAgent);
}

function handleAddToCartResponseGift(data, cartElement, operation) {

  window.upsellLogic();
  let item = data.items_removed ? data.items_removed[0]: data;  
  item["sections"] = data.sections;
  cartElement.setActiveElement(document.activeElement);
  cartElement.renderContents(item);
  const cartDrawer = document.querySelector('cart-drawer');
    cartDrawer.classList.toggle('is-empty', operation === 0);

  toggleSpinner(false);
}

function toggleSpinner(show) {
  const button = document.querySelector(".product-form__buttons button");
  const spinner = document.querySelector(".loading-overlay__spinner");

  if (spinner) {
    if (show) {
      button.style.opacity = "0.5";
      spinner.classList.remove("hidden");
    } else {
      spinner.classList.add("hidden");
      button.style.opacity = "";
    }
  }
}

document.updateCartGift = updateCartGift;

document.addEventListener('cart-remove-item-test', function() {
  setTimeout(() => {
    updateCartGift();
  }, 1500);
});
